__turbopack_context__.v({
  "action": "Content-module-scss-module__efjqVG__action",
  "content": "Content-module-scss-module__efjqVG__content",
  "limitWidth": "Content-module-scss-module__efjqVG__limitWidth",
});
